import { writable } from 'svelte/store'

export const image_list = writable<File[]>([])
export const renderedImageCache = writable<{ [key: string]: string }>({})

export const paymentDialogOpen = writable<boolean>()
